import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {ReminderModel} from "./ReminderModel";

export class ReminderBunch extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ReminderBunch, v) : SKIP;
            },
            (v) => {
                return deserialize(ReminderBunch, v);
            }
        );
    }

    constructor() {
        super();
        this._items = [];
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    valid() {

        if (this.items && this.items.some(v => !v || !v.valid() || v.empty())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.items || this.items.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ReminderBunch());
        } else if (target instanceof ReminderBunch) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ReminderBunch, {
    _items: alias("items", list(ReminderModel.schema()))
})